import {SearchFilterModel} from '../../models/SearchFilter-model';
import {VehicleDataEnum} from '../../models/VehicleData-model';

// These were the six autocomplete entries at the top of the dropdown. The
// lowercase Import table columns with similar names remain valid filters.
const removedAutocompleteFields = new Set<string>(Object.values(VehicleDataEnum));

export function isAvailableFileServiceFilter(option: string): boolean {
    return !removedAutocompleteFields.has(option);
}

export function keepAvailableFileServiceFilters(filters: SearchFilterModel[]): SearchFilterModel[] {
    return filters.filter(filter => filter && isAvailableFileServiceFilter(filter.option));
}
